<template lang="pug">
  .b2b-table-recadvs-received
    //- Filtros Tabla Servicios
    b2b-filters-recadvs-received(:filter-options='options')

    ods-table(
      :data='recadvsReceived.tableData',
      :default-sort='{prop: "creationDateTime", order: "descending"}',
      style='width: 100%',
      @sort-change='orderOnServer',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='small',
      :cell-class-name='paintCell',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='buyerName',
        :label='$t("recadv.recadv_entity_table.buyer")',
        :show-overflow-tooltip='true',
        v-if='isShowBuyerRecadvReceived',
        sortable='')
      //- centreBuyerCodes oculta por defecto
      ods-table-column(
        prop='centreBuyerCodes',
        :label='$t("recadv.recadv_entity_table.buyer_centre")',
        :show-overflow-tooltip='true',
        v-if='isShowCentroCompradorRecadvReceived && canViewDistributionCentres'
        sortable='')
      ods-table-column(
        prop='centreDeliveryCodes',
        :label='$t("recadv.recadv_entity_table.delivery_centre")',
        :show-overflow-tooltip='true',
        v-if='isShowCentroEntregaRecadvReceived && canViewDistributionCentres',
        sortable='')
      ods-table-column(
        prop='sellerName',
        :label='$t("recadv.recadv_entity_table.seller")',
        :show-overflow-tooltip='true',
        v-if='isShowSellerRecadvReceived',
        sortable='')
      //- centreSellerCodes oculta por defecto
      ods-table-column(
        prop='centreSellerCodes',
        :label='$t("recadv.recadv_entity_table.seller_centre")',
        :show-overflow-tooltip='true',
        v-if='isShowCentroVendedorRecadvReceived'
        sortable='')
      ods-table-column(
        prop='recadvNumber',
        :label='$t("recadv.recadv_entity_table.num_recadv")',
        :show-overflow-tooltip='true',
        v-if='isShowNumRecadvReceived',
        sortable='')
      ods-table-column(
        prop='receivingDateTime',
        :label='$t("recadv.recadv_entity_table.date_receiving")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateReceivingRecadvReceived',
        :formatter="formatterDate",
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("recadv.recadv_entity_table.date_creation")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateCreationRecadvReceived',
        :formatter="formatterDateTime",
        sortable='')
      ods-table-column(
        prop='statusId',
        :label='$t("recadv.recadv_entity_table.status")',
        v-if='isShowStatusRecadvReceived',
        sortable='')
         template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterTooltipInvoiceStatus(scope.row, scope.column) }}
            div.text-overflow-tooltip
              | {{ formatterStatus(scope.row, scope.column) }}
      ods-table-column(
        prop='projectName',
        :label='$t("recadv.recadv_entity_table.services")',
        :show-overflow-tooltip='true',
        v-if='isShowServiceRecadvReceived',
        sortable='')

      //- Ocultas por defecto
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='120')
        template(slot-scope='scope' placement='center')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('recadv.recadv_detail.download_pdf_buttons_tooltip') }}
            ods-button(
              v-if='!cantViewRecadvPdf',
              style=' padding-left: 0px; padding-right: 0px;',
              type='neutral',
              icon-position='left'
              @click='handleDownloadPdf(scope.row)')
              ods-icon(name='download', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          ods-popover(
            v-if= "canDoAnyAction(scope)"
          placement="bottom-end"
          trigger="hover")
            ul.__quick-accions
              li
                ods-button(
                  v-if="canViewRecadvOriginal && scope.row.path != null"
                  icon='ods-icon-download'
                  icon-position='left'
                  @click.native='handleDownloadOriginal(scope.row)' type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('invoice_detail.buttons.download_original_signed_tooltip')}}
              li
                ods-button(
                  v-if="scope.row.pathRecadvMetadata != null && canViewRecadvMetadata",
                  icon='ods-icon-file'
                  icon-position='left'
                  @click.native="handleDownloadMetadata(scope.row)" type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('buttons.btnViewMetadata')}}
              li
                ods-button(
                  v-if='(canCreateInvoiceRecadv || canCreateInvoiceParcialRecadv) && scope.row.statusId !== "REJECTED" && scope.row.statusId !== "ERROR" && scope.row.statusId !== "FULLY_INVOICED"',
                  icon='ods-icon-plus'
                  icon-position='left'
                  @click.native="handleCreateInvoice(scope.row)" type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('recadv.recadv_detail.create_invoice_buttons_tooltip')}}
            ods-button(
              slot="reference",
              icon-position='right'
              type='neutral')
              ods-icon(name='overflow-menu', size='16')
    ods-row.b2b-table-recadvs-received__pagination(v-if='recadvsReceived.totalRecadvsReceived > 0')
      ods-col.b2b-table-recadvs-received__pagination--left(:span='1')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round,
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadCsv')
            | CSV
      ods-col.b2b-table-recadvs-received__pagination--left(:span='3')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_details_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round,
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadCsvDetails')
            | {{ $t('invoices.buttons.download_csv_details') }}
      //- Paginación Tabla
      ods-col.b2b-table-recadvs-received__pagination--right(:span='19', style='margin-left: 20px',)
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='recadvsReceived.totalRecadvsReceived')

    //- Recepciones  Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
        div(slot='actions')
          ods-tooltip(:content='$t("recadv.recadv_detail.download_pdfmultiple_buttons_tooltip")', placement='bottom')
            ods-button(
              v-if='!cantViewRecadvPdf',
              icon='ods-icon-download',
              size='small',
              circle,
              @click.native='handleDownloadPdfMultiple')
              | {{ $t('recadv.recadv_detail.download_pdfmultiple_buttons') }}
          ods-tooltip(:content='$t("recadv.recadv_detail.create_invoice_buttons_tooltip")', placement='bottom')
            ods-button(
              v-if='(canCreateInvoiceRecadv || canCreateInvoiceParcialRecadv) && canCreateInvoicesList',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='handleCreateInvoice')
              | {{ $t('recadv.recadv_detail.create_invoice_buttons') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersRecadvsReceived from '@/views/recepciones/recibidas/B2bFiltersRecadvsReceived'
import B2bTableMenuRecadvsReceived from '@/views/recepciones/recibidas/B2bTableMenuRecadvsReceived'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-recepciones-recibidas'
import Utils from '@/components/shared/Utils'
import moment from 'moment'

export default {
  name: 'b2b-table-recadvs-received',
  mixins: [Utils],
  data () {
    return {
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      totalResults: 0,
      currentPage: 0,
      canCreateInvoicesList: false,
      searchType: 'RECEIVED'
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'recadvsReceived',
      'queryRecadvsReceived',
      'isShowBuyerRecadvReceived',
      'isShowSellerRecadvReceived',
      'isShowNumRecadvReceived',
      'isShowDateReceivingRecadvReceived',
      'isShowDateCreationRecadvReceived',
      'isShowStatusRecadvReceived',
      'isShowServiceRecadvReceived',
      'isShowCentroCompradorRecadvReceived',
      'isShowCentroEntregaRecadvReceived',
      'isShowCentroVendedorRecadvReceived',
      'canCreateInvoiceRecadv',
      'canCreateInvoiceParcialRecadv',
      'optionsFilterService',
      'getActiveLang',
      'canViewRecadvOriginal',
      'canViewRecadvMetadata',
      'canViewDistributionCentres',
      'cantViewRecadvPdf'
    ])
  },

  components: {
    B2bFiltersRecadvsReceived,
    B2bTableMenuRecadvsReceived,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'getRecadvs',
      'queryRecadvsReceivedState',
      'downloadRecadvPdfMultiple',
      'downloadCsv',
      'validaCreateInvoiceFromList',
      'createInvoiceState',
      'isShowServiceRecadvReceivedAction',
      'downloadRecadvOriginal',
      'downloadRecadvMetadata',
      'optionsFilterServiceState'
    ]),

    // Pinta en rojo el campo F.Asicada en las recepciones rechazadas
    paintCell ({ row, column, rowIndex, columnIndex }) {
      if (row.statusId === 'REJECTED' && column.property === 'invoiceNumber') {
        return 'colorred'
      }
    },
    // Descargar todos a CSV
    async handleDownloadCsv () {
      if (this.recadvsReceived.totalRecadvsReceived > 120000) {
        this.$notify({
          title: this.$t('recadv.recadv_entity_table.csv_title'),
          message: this.$t('recadv.recadv_entity_table.csv_message', { argumento: '120.000' }),
          type: 'Warning',
          iconClass: 'ods-icon-warning',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.download_csv')
        })
        const params = this.queryRecadvsReceived
        try {
          params.activeLang = this.getActiveLang
          params.isDetails = false
          const filename = await this.downloadCsv(params)

          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Descargar todos a CSV con detalles lineas
    async handleDownloadCsvDetails () {
      if (this.recadvsReceived.totalRecadvsReceived > 200) {
        console.log(this.recadvsReceived.totalRecadvsReceived)
        this.$notify({
          title: this.$t('recadv.recadv_entity_table.csv_title'),
          message: this.$t('recadv.recadv_entity_table.csv_details_message'),
          type: 'Warning',
          iconClass: 'ods-icon-warning',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.download_csv')
        })

        const params = this.queryRecadvsReceived
        try {
          params.activeLang = this.getActiveLang
          params.isDetails = true
          const filename = await this.downloadCsv(params)

          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Descarga múltiple de pdf
    async handleDownloadPdfMultiple () {
      const paramsValues = this.multipleSelectionIds.filter((item, index, self) => {
        return index === self.indexOf(item)
      })
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          recadvsIds: [paramsValues],
          searchType: this.searchType
        }

        const filename = await this.downloadRecadvPdfMultiple(params)
        this.$notify({
          title: this.$t('recadv.recadv_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Creación de una factura
    async handleCreateInvoice (recadv) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      let idList = []
      if (recadv && recadv.id) {
        idList = [recadv.id]
      } else {
        idList = this.multipleSelection.map(item => item.id)
      }

      try {
        const params = {
          recadvsIds: idList,
          searchType: this.searchType
        }
        await this.validaCreateInvoiceFromList(params)

        const invoice = {
          idRecadvs: idList
        }
        await this.createInvoiceState(invoice)

        router.push({ name: 'creacionmulti-factura-recepciones-recibidas', query: { type: 'RECADV_RECEIVED' } })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })
      try {
        let stringSort = ''
        const dataQuery = {
          query: {}
        }
        if (order === 'descending') {
          order = 'DESC'
        } else if (order === 'ascending') {
          order = 'ASC'
        } else {
          order = 'ASC'
        }

        if (!prop) {
          prop = 'creationDateTime'
        } else {
          switch (prop) {
            case 'buyerName':
              prop = 'partyByIdBuyer.tradeName'
              break
            case 'sellerName':
              prop = 'partyByIdSeller.tradeName'
              break
            case 'centreBuyerCodes':
              prop = 'centreBuyer.centreCode'
              break
            case 'centreDeliveryCodes':
              prop = 'centreDeliveryPoint.centreCode'
              break
            case 'centreSellerCodes':
              prop = 'centreSeller.centreCode'
              break
            case 'statusId':
              prop = 'statusDocument.status'
              break
          }
        }

        stringSort = prop + ',' + order
        this.queryRecadvsReceived.sort = stringSort
        await this.queryRecadvsReceivedState(this.queryRecadvsReceived)
        const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC', isSender: true }
        const optionsFilterService = await this.getOptionsService(dataQueryProj)
        await this.optionsFilterServiceState(optionsFilterService)
        if (optionsFilterService.length === 1) {
          this.queryRecadvsReceived.projectId = optionsFilterService[0].id
        }
        dataQuery.query = this.queryRecadvsReceived
        const response = await this.getRecadvs(dataQuery)
        this.totalResults = response.data.totalElements
        this.currentPage = response.data.number + 1
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      console.log('val.length ', val.length)
      if (val.length === 0) {
        this.multipleSelection = []
        this.canCreateInvoicesList = false
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
      // if (val.length > 0) { de momento no dejamos crear desde múltiple selección
      if (val.length === 1) {
        const projects = []
        const buyers = []
        const sellers = []
        const status = []
        const centres = []

        this.multipleSelection.forEach(r => {
          if (projects.indexOf(r.projectName) < 0) projects.push(r.projectName)
          if (buyers.indexOf(r.buyerName) < 0) buyers.push(r.buyerName)
          if (sellers.indexOf(r.sellerName) < 0) sellers.push(r.sellerName)
          if (status.indexOf(r.statusId) < 0) status.push(r.statusId)
          if (centres.indexOf(r.centreCode) < 0) centres.push(r.centreCode)
        })

        if (projects.length === 1 && buyers.length === 1 &&
            sellers.length === 1 && status.length === 1 && centres.length === 1 &&
            ((status[0] === 'RECEIVED' && this.canCreateInvoiceRecadv) ||
            (status[0] === 'PARTIALLY_INVOICED' && this.canCreateInvoiceParcialRecadv))) {
          this.canCreateInvoicesList = true
        } else {
          this.canCreateInvoicesList = false
        }
      } else if (val.length > 1) {
        this.canCreateInvoicesList = false
      }
    },

    // Descarga de pdf
    async handleDownloadPdf (recadv) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          recadvsIds: [recadv.id],
          searchType: this.searchType
        }
        const filename = await this.downloadRecadvPdfMultiple(params)
        this.$notify({
          title: this.$t('recadv.recadv_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    canDoAnyAction (scope) {
      return (this.canViewRecadvOriginal && scope.row.path != null) || (scope.row.pathRecadvMetadata != null && this.canViewRecadvMetadata) ||
       ((this.canCreateInvoiceRecadv || this.canCreateInvoiceParcialRecadv) && scope.row.statusId !== 'REJECTED' && scope.row.statusId !== 'FULLY_INVOICED')
    },

    /* Ir al detalle */
    handleGoDetail (recadv) {
      sessionStorage.setItem('recadvNumber', recadv.recadvNumber)
      router.push({
        name: 'recadv-received-detail',
        params: {
          recadvId: recadv.id,
          recadvNumber: recadv.recadvNumber
        }
      })
    },

    async handleDownloadOriginal (recadv) {
      this.handleCellMouseEnter(recadv)
      console.log('handleDownloadOriginal: ', recadv.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const params = {
          recadvsId: recadv.id,
          searchType: this.searchType
        }
        const filename = await this.downloadRecadvOriginal(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleDownloadMetadata (recadv) {
      this.handleCellMouseEnter(recadv)
      console.log('handleDownloadMetadata: ', recadv.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })
      try {
        const params = {
          recadvsId: recadv.id,
          searchType: this.searchType
        }
        const filename = await this.downloadRecadvMetadata(params)
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    formatterStatus (row, column) {
      if (row.statusId != null && row.statusId === 'REJECTED') {
        if (row.rejectSeller) {
          const REJECTED_SELLER = 'REJECTED_SELLER'
          return this.$t('recadv_status.' + REJECTED_SELLER)
        } else {
          return this.$t('recadv_status.' + row.statusId)
        }
      } else {
        // Distinto de rechazada
        return row.statusId != null ? this.$t('recadv_status.' + row.statusId) : null
      }
    },

    formatterTooltipInvoiceStatus (row, column) {
      if (row.messageStatus && row.messageStatus !== '') return row.messageStatus
      else return this.formatterStatus(row, column)
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Formatear columna: Fecha */
    formatterDateTime (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuRecadvsReceived />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = {
          query: {
            searchType: 'EMITTED'
          }
        }

        this.queryRecadvsReceived.size = val
        await this.queryRecadvsReceivedState(this.queryRecadvsReceived)
        dataQuery.query = this.queryRecadvsReceived
        const response = await this.getRecadvs(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      try {
        const dataQuery = {
          query: {}
        }
        this.queryRecadvsReceived.page = val - 1
        await this.queryRecadvsReceivedState(this.queryRecadvsReceived)
        dataQuery.query = this.queryRecadvsReceived

        const response = await this.getRecadvs(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.options = filters.filters

      this.isShowServiceRecadvReceivedAction(true)
      if (this.optionsFilterService.length < 2) {
        this.isShowServiceRecadvReceivedAction(false)
      }
    } catch (error) {
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}

</script>

<style lang="scss" scoped>
.b2b-table-recadvs-received {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .cell {
        .text-overflow-tooltip {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }

  ::v-deep td.colorred div{
    color:red;
  }
  ::v-deep .ods-col {
    min-width: 80px;
  }
}
</style>
